import { IdFieldsInfo } from 'app/components/Song/Contributions/ContributionForm/RoleFields/types';
import { useFormContext } from 'react-hook-form';
import { ContributionFormData } from 'app/components/Song/Contributions/ContributionForm/types';
import React from 'react';
import { InputField } from 'app/components/Core';
import { Icon, Tooltip } from '@chakra-ui/react';
import { ReactComponent as InformationIcon } from 'resources/images/info.svg';

interface IPNFieldProps {
  IPNFieldInfo: IdFieldsInfo;
  disabled?: boolean;
}

export const IPNField: React.FC<IPNFieldProps> = ({
  IPNFieldInfo,
  disabled,
}) => {
  const {
    formState: { errors },
    register,
  } = useFormContext<ContributionFormData>();

  return IPNFieldInfo ? (
    <InputField
      key={IPNFieldInfo.idFieldName}
      label={IPNFieldInfo.idFieldLabel}
      isDisabled={disabled}
      isInvalid={Boolean(errors?.[IPNFieldInfo.idFieldName])}
      errorMessage={errors?.[IPNFieldInfo.idFieldName]?.message}
      rightElement={
        <Tooltip hasArrow label={IPNFieldInfo.tooltip}>
          <Icon
            as={InformationIcon}
            cursor="pointer"
            color="iconBase"
            w={5}
            h={5}
            data-testid="tooltip-icon"
          />
        </Tooltip>
      }
      data-testid="className-id-field"
      overflow="hidden"
      textOverflow="ellipsis"
      {...register(IPNFieldInfo.idFieldName)}
    />
  ) : null;
};
